import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import { 
  FaFacebook, FaInstagram, FaLinkedin, FaYoutube, 
  FaTwitter, FaWhatsapp, FaTelegram, FaEnvelope, 
  FaPhone, FaMapMarkerAlt 
} from 'react-icons/fa';
import logo from '../assets/logofooter.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const services = [
    "Adam Commerce", "Adam Education", "Adam Consultancy", 
    "Adam Economy", "Adam Industry", "Adam Construction", 
    "Adam Technology", "Adam Services", "Adam Charity"
  ];
  
  const quickLinks = [
    { path: "/", label: "Home" },
    { path: "/sectors", label: "Sectors" },
    { path: "/about", label: "About Us" },
    { path: "/announcements", label: "Announcements" },
    { path: "/platforms", label: "Platforms" },
    { path: "/contact", label: "Contact" }
  ];
  
  const socialLinks = [
    { icon: <FaFacebook />, url: "https://www.facebook.com/adamholdingunion", label: "Facebook" },
    { icon: <FaInstagram />, url: "https://www.instagram.com/adamholdingunio", label: "Instagram" },
    { icon: <FaLinkedin />, url: "https://tr.linkedin.com/in/adamholdingunion", label: "LinkedIn" },
    { icon: <FaYoutube />, url: "https://www.youtube.com/@AdamHoldingUnion", label: "YouTube" },
    { icon: <FaTwitter />, url: "https://x.com/adamholdingunio", label: "Twitter" },
    { icon: <FaWhatsapp />, url: "https://whatsapp.com/channel/0029VazMYkUJuyA5dZD95u3p", label: "WhatsApp" },
    { icon: <FaTelegram />, url: "https://t.me/adamholdingunion", label: "Telegram" }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-column footer-company">
          <div className="footer-logo-container">
            <img src={logo} alt="ADAM Holding Logo" className="footer-logo" />
            <h3 className="footer-company-name">ADAM HOLDING UNION</h3>
          </div>
          <p className="footer-description">
            A global associate group of companies and a leading corporate and entrepreneurial 
            services firm delivering world-class solutions across international borders.
          </p>
          <div className="footer-social">
            {socialLinks.map((social, index) => (
              <a 
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label={social.label}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-column footer-links">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-list">
            {quickLinks.map((link, index) => (
              <li key={index} className="footer-list-item">
                <Link to={link.path} className="footer-link">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div className="footer-column footer-services">
          <h3 className="footer-title">Our Services</h3>
          <ul className="footer-list">
            {services.map((service, index) => (
              <li key={index} className="footer-list-item">
                <span className="footer-service">{service}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-column footer-contact">
          <h3 className="footer-title">Contact Us</h3>
          <ul className="footer-list">
            <li className="footer-contact-item">
              <FaMapMarkerAlt className="footer-contact-icon" />
              <div>
                <h4>Headquarters</h4>
                <p>Istanbul, Turkey</p>
              </div>
            </li>
            <li className="footer-contact-item">
              <FaPhone className="footer-contact-icon" />
              <div>
                <h4>Phone</h4>
                <a href="tel:+905380772631" className="footer-contact-link">
                  +90 538 077 26 31
                </a>
              </div>
            </li>
            <li className="footer-contact-item">
              <FaEnvelope className="footer-contact-icon" />
              <div>
                <h4>Email</h4>
                <a href="mailto:info@adamholdingunion.com" className="footer-contact-link">
                  info@adamholdingunion.com
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p className="footer-copyright">
            &copy; {currentYear} ADAM Holding Union. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="/privacy" className="footer-legal-link">Privacy Policy</a>
            <span className="footer-separator">|</span>
            <a href="/terms" className="footer-legal-link">Terms of Service</a>
            <span className="footer-separator">|</span>
            <a href="/cookies" className="footer-legal-link">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;